import { render } from "./process-group-update.vue?vue&type=template&id=1ca3bb4b"
import script from "./process-group-update.vue?vue&type=script&lang=js"
export * from "./process-group-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__